// QuizResults.tsx
import { memo } from "react";
import { Certificate } from "./Certificate";

interface QuizResultsProps {
  title: string;
  studentName: string;
  score: number;
  total: number;
  percentage: number;
  passed: boolean;
  primaryColor: string;
  onRestart: () => void;
}

export const QuizResults = memo(({ title, studentName, score, total, percentage, passed, primaryColor, onRestart }: QuizResultsProps) => (
  <div className="max-w-4xl mx-auto p-6">
    <div className="bg-white rounded-3xl shadow-xl border overflow-hidden">
      <div className={`${primaryColor} text-white p-8 text-center`}>
        <h1 className="text-4xl font-bold mb-2">Quiz Completed 🎉</h1>
        <p className="text-lg opacity-90">{title}</p>
      </div>

      <div className="p-8 text-center">
        <ResultStats score={score} total={total} percentage={percentage} passed={passed} />
        
        {passed && <Certificate title={title} studentName={studentName} percentage={percentage} />}

        <div className="flex flex-wrap items-center justify-center gap-4">
          {passed && <PrintCertificateButton primaryColor={primaryColor} />}
          <RestartQuizButton onRestart={onRestart} />
        </div>
      </div>
    </div>
  </div>
));

const ResultStats = ({ score, total, percentage, passed }: any) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
    <StatCard label="Score" value={`${score}/${total}`} />
    <StatCard label="Percentage" value={`${percentage}%`} />
    <StatCard label="Result" value={passed ? "PASSED" : "FAILED"} valueClassName={passed ? "text-green-600" : "text-red-600"} />
  </div>
);

const StatCard = ({ label, value, valueClassName = "" }: any) => (
  <div className="border rounded-2xl p-5">
    <p className="text-gray-500 mb-1">{label}</p>
    <h2 className={`text-3xl font-bold ${valueClassName}`}>{value}</h2>
  </div>
);

const PrintCertificateButton = ({ primaryColor }: { primaryColor: string }) => (
  <button onClick={() => window.print()} className={`${primaryColor} text-white px-6 py-3 rounded-2xl hover:opacity-90 transition`}>
    Print Certificate
  </button>
);

const RestartQuizButton = ({ onRestart }: { onRestart: () => void }) => (
  <button onClick={onRestart} className="border px-6 py-3 rounded-2xl hover:bg-gray-100 transition">
    Restart Quiz
  </button>
);

QuizResults.displayName = "QuizResults";